const RENAMEABLE_ERROR_NAMES = [
  'Error',
  'TypeError',
  'AxiosError',
  'UnknownError',
  'UnhandledPromiseRejectionError',
]; // generic names AppSignal cannot group usefully

export const shouldRenameError = (error: unknown): boolean => {
  if (!(error instanceof Error)) return false;

  return RENAMEABLE_ERROR_NAMES.includes(error.name);
};
